module.exports = __webpack_public_path__ + "img/plant-hand.402b0597.png";